import React from 'react';
import { ITableBody } from './table.model';
import cx from 'classnames';
import styles from './table.module.scss';

const TableBody = (props: ITableBody) => {
  const { children, className } = props;

  const classNames = cx(className);

  return <tbody className={classNames}>{children}</tbody>;
};

export default TableBody;

TableBody.displayName = 'Table.Body';
